import { useInfiniteQuery } from '@tanstack/react-query';
import { queryKey } from '../../../../../constant/queryKey';
import { goodsService } from 'shared/src/api';
import type { GetRankingGoodsRequest } from 'shared/src/api';

export const useRankingGoods = (
  params: Omit<GetRankingGoodsRequest, 'last_ranking'>,
) => {
  return useInfiniteQuery({
    queryKey: queryKey.rankingGoods(params),
    queryFn: ({ pageParam }) =>
      goodsService.getRankingGoods({
        ...params,
        last_ranking: pageParam,
      }),
    initialPageParam: 0,
    getNextPageParam: lastPage => {
      const lastGoods = lastPage.goods[lastPage.goods.length - 1];
      return lastGoods ? lastGoods.ranking : undefined;
    },
    select: data => ({
      ...data.pages[data.pages.length - 1],
      goods: data.pages.flatMap(page => page.goods),
    }),
  });
};
